export type FieldError = { code: 'required' | 'email' | 'short' | 'long' | 'invalid'; limit?: number };
export type FieldErrors = Record<string, FieldError>;

export function validateField(field: {
  value: string; required: boolean; typeMismatch?: boolean; patternMismatch?: boolean; minLength?: number; maxLength?: number;
}): FieldError | undefined {
  const value = field.value.trim();
  if (!value) return field.required ? { code: 'required' } : undefined;
  if (field.typeMismatch) return { code: 'email' };
  if (field.minLength && field.minLength > 0 && value.length < field.minLength) return { code: 'short', limit: field.minLength };
  if (field.maxLength && field.maxLength > 0 && field.value.length > field.maxLength) return { code: 'long', limit: field.maxLength };
  if (field.patternMismatch) return { code: 'invalid' };
  return undefined;
}

export function validateForm(form: HTMLFormElement): FieldErrors {
  const errors: FieldErrors = {};
  for (const element of Array.from(form.elements)) {
    if (!(element instanceof HTMLInputElement || element instanceof HTMLTextAreaElement)) continue;
    if (!element.name || element.disabled || (element instanceof HTMLInputElement && ['hidden', 'radio', 'checkbox'].includes(element.type))) continue;
    const error = validateField({
      value: element.value, required: element.required,
      typeMismatch: element.validity.typeMismatch, patternMismatch: element.validity.patternMismatch,
      minLength: element.minLength, maxLength: element.maxLength
    });
    if (error) errors[element.name] = error;
  }
  return errors;
}
